/* eslint-disable no-mixed-operators */
import { useState, useEffect } from 'react';
import Storage from '../../services/Storage';
import Http from '../../services/Http';
import { useParams } from 'react-router-dom';
import QueryParams from '../../services/QueryParams';
import './index.scss';
import Login from './Login';

let tokenSent = false;

const SSO = (props: any) => {
    const http = new Http();
    const storage = new Storage();
    const { app } = useParams<any>();
    const queryParams = new QueryParams();
    const onScreenLogin = queryParams.get("onScreen") ? true : false;

    let [state, setState] = useState({
        token: storage.token(),
        ready: false,
        success: false,
        redirect: `${process.env.REACT_APP_BASE_URL}/login?returnTo=${encodeURIComponent(queryParams.get("returnTo"))}`,
        message: "",
        user: null,
        app: app,
        session: ""
    });

    let [showLogin, setShowLogin] = useState(false);

    const sendToken = () => {
        if (window && window.parent) {
            setShowLogin(false);
            window.parent.postMessage({
                type: "SSO",
                name: "SSO Token",
                ...state
            }, '*');
        }
    };

    const initOnScreenLogin = (hide?: boolean | undefined | null) => {
        storage.remove("sso_token");
        window.parent.postMessage({
            type: "SSO",
            name: "SSO On Screen Login",
            show: hide ? false : true
        }, '*');
        setShowLogin(true);
    };

    useEffect(() => {
        if (!tokenSent && state.message) {
            tokenSent = true;
            sendToken();
            console.log("Calling send token");
        } else {
            console.log("Not sending token", tokenSent, state.message);
        }
    }, [state]);

    const getSession = () => {
        if (state.ready) return;
        // Validate session
        let stData1: any = {
            ...state,
            ready: true
        };

        setState(stData1);   // Making sure this is not getting triggered twice

        let stData2: any = { ...stData1 };

        const handleError = (resp: any) => {
            console.log(resp);
            switch (resp.status) {
                case 401:
                    console.log(onScreenLogin);
                    if (onScreenLogin) {
                        initOnScreenLogin();
                    } else {
                        stData2.message = `${resp.data.message} Redirecting you to insurEco account...}`;
                        setState(stData2);
                    }
                    break;

                case 403:
                    stData2.message = `Forbidden! You are not allowed to access ${state.app.toUpperCase()} App.`;
                    stData2.redirect = `${process.env.REACT_APP_BASE_URL}/sso-error?message=${stData2.message}`;
                    setState(stData2);
                    break;

                default:
                    alert(resp.data && resp.data.message || resp);
                    break;
            }
        };

        http.secureGet(`authenticate/${state.app}?url=${encodeURIComponent(queryParams.get("returnTo"))}`)
            .then((resp: any) => {
                console.log(resp);
                stData2.token = resp.data.token;
                if (resp.status === 200) {
                    stData2.success = true;
                    stData2.message = resp.data.message;
                    stData2.session = resp.data.session;
                    setState(stData2);
                } else {
                    handleError(resp);
                }
            })
            .catch((error: any) => {
                if (error.response) {
                    handleError(error.response);
                } else {
                    console.log(error);
                    handleError(error && error.message || "Something went wrong.");
                }
            });
    };

    useEffect(() => {
        getSession();
    });

    const logout = (force?: boolean) => {
        if (window.self !== window.top) {
            window.parent.postMessage({
                type: "SSO",
                name: "SSO Logout",
                success: storage.token() ? false : true,
                force: force
            }, '*');
        } else {
            window.location.href = "/login";
        }
    };

    window.addEventListener("message", function (e) {
        if (e.data && e.data.type === "SSO") {
            switch (e.data.name) {
                case "SSO Logout":
                    storage.remove("sso_token");
                    logout(e.data.force);
                    break;

                case "SSO Token":
                    // Ignore parent event triggered on self
                    if (window.self !== window.top) {
                        console.log("Token Request Received");
                        tokenSent = false;
                        let stData3: any = {
                            ...state,
                            token: storage.token(),
                            ready: false,
                            success: false,
                            message: "",
                            user: null,
                            app: app,
                            session: ""
                        };

                        setState(stData3);
                    }
                    break;

                default:
                    alert("Unhandled SSO Event '" + e.data.name + "'.");
                    break;
            }
            console.log(e.data);
        }
    });

    window.addEventListener("storage", function (e: any) {
        if (!storage.token() && !showLogin) {
            console.log("Storage triggering logout");
            logout(true);
        }
    });

    return showLogin ? <Login isOnScreen={true} logout={logout} getSession={getSession} /> : <span></span>;
}

export default SSO;